<!--
Author: TangChen
Date: 2018-09-17
Desc: 我的资产组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-assets bizcomp ' + className">
        <comp-title :title="title" />
        <el-row v-if="planNum+assetsNum+privateNum+orderNum > 0" class="risk-change">
            <div class="risk-change-box">
                <i class="fa fa-exclamation-triangle" />
                <div class="risk-change-mes">
                    <p>
                        由于您的个人风险等级或产品风险等级变动，存在<span class="red">（{{ planNum+assetsNum+privateNum+orderNum }}）</span>笔产品风险等级高于您的风险承受能力的交易，请阅读风险警示进行适当性处理。
                    </p>
                    <p class="red">
                        对于未处理的定期投资协议或预约交易，将不产生定投交易或预约交易申请。
                    </p>
                </div>
            </div>
        </el-row>
        <el-tabs v-model="activeName">
            <el-tab-pane name="first" class="fund-arr">
                <el-badge slot="label" :hidden="assetsNum === 0" :value="assetsNum" class="item">
                    我的持仓
                </el-badge>
                <asset-fund :fund-info="fundInfo" :is-risk="assetsNum" v-on:fund-continue="fundCon" />
            </el-tab-pane>
            <el-tab-pane name="second">
                <el-badge slot="label" :hidden="planNum===0" :value="planNum" class="item">
                    定投计划
                </el-badge>
                <el-table :data="gfund" style="width: 100%" class="tab-list-tit">
                    <el-table-column label="基金名称" width="280" class-name="fund-offset">
                        <template slot-scope="scope">
                            <i
                                v-if="scope.row.planflag==='2'||scope.row.planflag==='6'"
                                class="wisdom-icon"
                                title="智慧定投"
                            >智</i>
                            <span v-html="getFundName(scope.row)" />
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="firstinvestdate"
                        width="110"
                        label="首次扣款日期"
                        align="center"
                        :formatter="formatterDate"
                    />
                    <el-table-column prop="periodremark" label="扣款周期" width="110" align="center" />
                    <el-table-column label="扣款金额" align="center">
                        <template slot-scope="scope">
                            <div v-html="formatterNum(scope.row.firstinvestamount)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="银行卡" align="center" width="240">
                        <template slot-scope="scope">
                            <div class="bank-img-sel list-bank">
                                <span class="k-text-flow">{{ $cache.getDict('110080',scope.row.channelid)+'[尾号'+scope.row.bankcard.substr(-4,4)+']' }}</span>
                                <!--<i class="paycenter">{{ $cache.getDict('110079',scope.row.paycenterid) }}</i>-->
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="定投状态" align="center" :formatter="formatterStatus" />
                    <el-table-column label="操作" align="center" :width="planNum>0?(lowriskflag==='1'?200:290):100">
                        <template slot-scope="scope">
                            <el-button
                                v-if="scope.row.iswarn!=='1'"
                                type="info"
                                plain
                                size="small"
                                v-on:click.stop="showDetail(scope.row.planno)"
                            >
                                查看明细
                            </el-button>
                            <div v-else class="btn-group">
                                <el-button
                                    v-if="scope.row.action.indexOf('a') > -1"
                                    type="yellow"
                                    size="mini"
                                    v-on:click.prevent="$router.push({name:'risk'})"
                                >
                                    重新评测
                                </el-button>
                                <el-button
                                    v-if="scope.row.action.indexOf('c') > -1"
                                    type="yellow"
                                    size="mini"
                                    v-on:click.prevent="fundCon('P4', scope.row)"
                                >
                                    继续协议
                                </el-button>
                                <el-button
                                    v-if="scope.row.action.indexOf('p') > -1"
                                    type="blue"
                                    size="mini"
                                    v-on:click.prevent="fundCon('G1,P8', scope.row)"
                                >
                                    暂停协议
                                </el-button>
                                <el-button
                                    v-if="scope.row.action.indexOf('s') > -1"
                                    type="lock"
                                    size="mini"
                                    v-on:click.prevent="fundCon('60,P5', scope.row)"
                                >
                                    终止协议
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
<!--            <el-tab-pane label="" name="third" class="fund-arr">-->
<!--                <el-badge slot="label" :hidden="privateNum === 0" :value="privateNum" class="item">-->
<!--                    专户理财-->
<!--                </el-badge>-->
<!--                <asset-fund :fund-info="privateInfo" :is-risk="privateNum" v-on:fund-continue="fundCon" />-->
<!--            </el-tab-pane>-->
            <!-- <el-tab-pane name="four">
                <el-badge slot="label" :hidden="orderNum === 0" :value="orderNum" class="item">
                    预约协议
                </el-badge>
                <el-table :data="orderInfo" style="width: 100%" class="tab-list-tit order-table">
                    <el-table-column label="基金名称" width="250" class-name="fund-offset">
                        <template slot-scope="scope">
                            <span v-html="getFundName(scope.row)" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="serialno" label="预约协议号" width="250" align="center" />
                    <el-table-column label="预约金额" align="center">
                        <template slot-scope="scope">
                            <div v-html="$util.fmtNum(scope.row.appamount)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="预约份额" align="center">
                        <template slot-scope="scope">
                            <div v-html="$util.fmtNum(scope.row.appvol)" />
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="investvalue"
                        width="110"
                        label="申请日期"
                        align="center"
                        :formatter="formatterDate"
                    />
                    <el-table-column label="业务名称" align="center">
                        <template slot-scope="scope">
                            <div v-html="$cache.getDict('130010', scope.row.businesscode)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="right" :width="250">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.iswarn === '1'" type="text" size="small" class="red" v-on:click.prevent="fundCon('P4', scope.row)">
                                <i class="fa fa-exclamation-triangle" />阅读风险警示
                            </el-button>
                            <el-tooltip
                                v-if="scope.row.status !== '0'"
                                class="item"
                                effect="info"
                                content="协议已终止"
                                placement="left"
                            >
                                <el-button type="lock" size="small">
                                    终止
                                </el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                type="danger"
                                plain
                                size="small"
                                v-on:click.stop="stopOrder(scope.row)"
                            >
                                终止
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane> -->
        </el-tabs>
        <risk-dialog :fund="fundDetail" v-on:event-fn="backFn" />
        <msg-dialog v-if="dialog" :dialog="dialog" :private-info="wisdomInfo" v-on:event-fn="backFn" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import assetFund from "@/components/fund/assetFund";
import riskDialog from "@/components/misc/riskDialog";
import msgDialog from "@/components/misc/msgDialog";
export default {
    name: "AssetsList",
    components: {
        assetFund,
        riskDialog,
        msgDialog
    },
    mixins: [mixin],
    data () {
        return {
            activeName: "first",
            gfund: [],
            fundInfo: [],
            privateInfo: [],
            orderInfo: [],
            assetsNum: 0,
            dialog: false,
            planNum: 0,
            privateNum: 0,
            orderNum: 0,
            fundDetail: {},
            xjbCode: "",
            lowriskflag: "0",
            wisdomInfo: {}
        };
    },
    created () {
        this.xjbCode = this.$cache.getXjbCode();
        this.lowriskflag = this.$cache.getUser().lowriskflag;
        this.getFundLists();
    },
    methods: {
        showDetail (id) {
            const fund = this.gfund.filter(item => {
                return item.planno === id;
            })[0];
            if (fund) {
                const _x = Object.assign({}, fund);
                sessionStorage.setItem("plandetail", JSON.stringify(_x));
                this.$router.push({ name: "plandetail", query: { fundcode: fund.fundcode } });
            }
        },
        formatterDate (row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterNum (value) {
            if (value.indexOf(",") > -1) {
                const _x = value.split(",");
                let _z = "";
                // 定转显示
                for (let i in _x) {
                    _z += this.$util.fmtNum(_x[i]) + "</br>";
                }
                return _z;
            }
            return this.$util.fmtNum(value);
        },
        formatterStatus (row, column, value) {
            return this.$cache.getDict("110008", value);
        },
        // 适当性基金信息校验
        fundCon (way, fund) {
            const _this = this;
            if (way === "24") {
                const _fund = _this.$util.dataTaacFilter(fund);
                if (!(this.xjbCode.indexOf(_fund.fundcode) > -1)) {
                    const _x = Object.assign({}, _fund, { way: way });
                    sessionStorage.setItem("sellfund", JSON.stringify(_x));
                    this.$router.push({ name: "sellfund", query: { fundcode: fund.fundcode } });
                } else {
                    this.$router.push({ name: "currencyredemption", query: { fundcode: _fund.fundcode } });
                }
            } else {
                let _url = "";
                // 购买
                if (way === "20,22") {
                    // 普通购买/定投
                    fund.proto = "plan";
                    this.$util.fundRiskCheck(this, fund, res => {
                        if (res) {
                            _this.$util.getSdxProtocol(res,data=>{
                                if(data){
                                    const _x = Object.assign({}, data, { way: way });
                                    _url = fund.fundtype === "4" ? "privatebuy" : "buyfund";
                                    if (fund.fundtype === "4") {
                                        _this.$util.request("pef/trade/prdlist", { fundcode: fund.fundcode }).then(pef => {
                                            if (pef.data) {
                                                const _y = Object.assign({}, _x, pef.data[0][0]);
                                                sessionStorage.setItem(_url, JSON.stringify(_y));
                                                _this.$router.push({ name: _url, query: { fundcode: _y.fundcode } });
                                            }
                                        });
                                    } else {
                                        sessionStorage.setItem(_url, JSON.stringify(_x));
                                        _this.$router.push({ name: _url, query: { fundcode: _x.fundcode } });
                                    }
                                }
                            });
                        }
                    });
                    //   阅读适当性协议
                } else if (way === "P4" || way === "P5" || way === "P8") {
                    this.fundDetail = Object.assign({}, fund, { way: way });
                } else if (way === "G1,P8" || way === "60,P5") { // 定投协议暂停和终止
                    this.btnAction(fund, way);
                }
            }
        },
        // 获取基金名称显示
        getFundName (val, flag) {
            let _k = "";
            let _m = ",";
            if (!flag) {
                _m = "<br/>";
                if (val.busitype === "7" || val.planpaytype === "2") {
                    _k = "<b class=\"wisdom-icon\" title=\"现金宝\">现</b>";
                }
            }
            if (val.fundcode.indexOf(",") === -1) {
                return _k + val.fundname + "(" + val.fundcode + ")";
            }
            const _x = val.fundcode.split(",");
            const _y = val.fundname.split(",");
            let _z = "";
            // 定转显示
            for (let i in _x) {
                _z += _k + _y[i] + "(" + _x[i] + ")" + _m;
            }
            return _z;
        },
        // 按钮响应处理
        btnAction (fund, way) {
            let _x = {};
            if (way === "G1,P8") {
                _x.cateText = "暂停";
                _x.opertype = "1";
            } else if (way === "60,P5") {
                _x.cateText = "终止";
                _x.opertype = "2";
            }
            _x.way = way;
            const _y = this.getFundName(fund, true);
            _x.msg = "您确定执行" + _y + _x.cateText + "定投协议操作？";
            _x.tit = _x.cateText + "定投协议提示";
            _x.btn1 = "确认" + _x.cateText;
            _x.btn2 = "取消";
            this.wisdomInfo = Object.assign({}, fund, _x);
            this.dialog = true;
        },
        // 适当性处理
        backFn (val) {
            const _this = this;
            this.dialog = false;
            if (val) {
                const _data = {
                    serialno: val.serialno,
                    busitype: val.busitype,
                    chgtype: val.chgtype,
                    opertype: val.opertype,
                    fundcode: val.fundcode,
                    riskwarnflag: val.riskwarnflag,
                    riskmismatchflag: val.riskmismatchflag,
                    highriskwarnflag: val.highriskwarnflag,
                    fundmismatchflag: val.fundmismatchflag,
                    saveplanflag: val.saveplanflag,
                    tradepwd: val.tpasswd
                };
                this.$util.request("acct/sdx/readwarn", _data, "POST").then(res => {
                    if (res.data) {
                        //针对预约协议处理
                        if (val.busitype === "4") {
                            _this.orderInfo.forEach((item, index) => {
                                if (item.serialno === val.serialno) {
                                    _this.$set(_this.orderInfo[index], "iswarn", "0");
                                }
                            });
                            /* _this.orderInfo = _this.orderInfo.filter( e => {
                                return e.serialno !== val.serialno;
                            }); */
                            _this.orderNum--;
                            return false;
                        }
                        //针对非预约协议处理
                        _this.updateData(val);
                    }
                });
            }
        },
        // 更新列表信息
        updateData (val) {
            let _index = -1;
            let _x = [];
            if (val.planflag) {
                _x = this.gfund;
            } else {
                if (val.fundtype === "4") {
                    _x = this.privateInfo;
                } else {
                    _x = this.fundInfo;
                }
            }
            _x.forEach((item, index) => {
                if (item.serialno === val.serialno) {
                    item.iswarn = "0";
                    // 暂停和终止属性修改
                    if (val.opertype === "1") {
                        item.status = "P";
                    } else if (val.opertype === "2") {
                        item.status = "C";
                    }
                    _index = index;
                    if (val.planflag) {
                        this.planNum--;
                    } else {
                        val.fundtype === "4" ? this.privateNum-- : this.assetsNum--;
                    }
                }
            });
            if (_index === -1) return;
            if (val.planflag) {
                this.$set(this.gfund, _index, _x[_index]);
            } else {
                if (val.fundtype === "4") {
                    this.$set(this.privateInfo, _index, _x[_index]);
                    return;
                }
                //针对在途
                if (val.busitype === "1"){
                    this.fundInfo = this.fundInfo.filter(e => {return e.serialno !== val.serialno;});
                    return;
                }
                this.$set(this.fundInfo, _index, _x[_index]);
            }
        },
        // 风险协议变动处理 s终止 c继续 p暂停 a重新评测
        riskBtnCheck (val) {
            if (val.chgtype === "0") {
                if (this.lowriskflag === "1" && val.risklevel > "01") {
                    return "s";
                } else {
                    if (val.planflag === "a" || val.planflag === "b") {
                        return "c,s";
                    }
                    return "c,p,s";
                }
            } else if (val.chgtype === "1") {
                if (this.lowriskflag === "1") {
                    return "a,s";
                } else {
                    if (val.planflag === "a" || val.planflag === "b") {
                        return "c,s";
                    }
                    return "c,p,s";
                }
            }
        },
        // 获取资产信息
        getFundLists () {
            const _this = this;
            this.$util.request("acct/asset/detail").then(res => {
                if (res.data && res.data[1]) {
                    _this.fundInfo = _this.$util.getCodeOnly(res.data[0], { code: "fundcode", noFilter: "busitype", noFilterVal: "1", data: ["marketvalue", "costmoney", "floatprofit","totalincome", "addincome", "appamount", "availablevol", "frozenvol", "balancevol"] });
                    _this.privateInfo = _this.$util.getCodeOnly(res.data[2], { code: "fundcode", noFilter: "busitype", noFilterVal: "1", data: ["marketvalue", "costmoney", "floatprofit","totalincome", "addincome", "appamount", "availablevol", "frozenvol", "balancevol"] });
                    _this.gfund = res.data[1];
                    // 合并组合定投基金
                    _this.gfund = _this.$util.getCodeOnly(_this.gfund, { code: "mainplanno", data: ["fundname", "fundcode", "risklevel", "firstinvestamount", "planno"] }, ",");
                    _this.gfund.forEach(item => {
                        item.action = "";
                        if (item.iswarn === "1" && ("2,3,4,6,7".indexOf(item.busitype) > -1)) {
                            item.action = _this.riskBtnCheck(item);
                            ++_this.planNum;
                        }
                    });
                    _this.fundInfo.forEach(item => {
                        if (item.iswarn === "1" && (item.busitype === "0" || item.busitype === "1")) {
                            ++_this.assetsNum;
                        }
                    });
                    _this.privateInfo.forEach(item => {
                        if (item.iswarn === "1" && (item.busitype === "0" || item.busitype === "1")) {
                            ++_this.privateNum;
                        }
                    });
                    // _this.orderInfo = res.data[3].filter(e => {return e.iswarn === "1";});
                    _this.orderInfo = res.data[3];
                    _this.orderNum = _this.orderInfo.filter(e => {return e.iswarn === "1";}).length;
                }
            });
        },
        stopOrder (data) {
            const _this = this;
            this.$confirm("您是否确认终止该预约协议？", "预约协议终止", {
                confirmButtonText: "终止",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                _this.$util.request("booking/sell/stop", { serialno: data.serialno, chgtype: data.chgtype }, "POST").then(res => {
                    if (res.data) {
                        _this.$message({
                            type: "success",
                            message: "终止预约协议成功"
                        });
                        _this.orderInfo.forEach((item, index) => {
                            if (item.serialno === data.serialno) {
                                _this.$set(_this.orderInfo[index], "status", "3");
                                _this.$set(_this.orderInfo[index], "iswarn", "0");
                            }
                        });
                        /* _this.orderInfo = _this.orderInfo.filter( e => {
                            return e.serialno !== data.serialno;
                        }); */
                        if (data.iswarn === "1") _this.orderNum--;
                    }
                });
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-assets {
    .risk-change {
        margin: 0 0 10px;
        .risk-change-box {
            padding: 8px 44px;
            background-color: $bg6;
            border-radius: 4px;
            position: relative;
            line-height: 26px;
            .fa-exclamation-triangle {
                position: absolute;
                left: 22px;
                top: 14px;
                color: $color-c;
            }
            .red {
                color: $color-c;
            }
        }
    }
    .wisdom-icon {
        font-size: $f12;
        display: inline-block;
        font-style: normal;
        background-color: $color-c;
        color: $text-color6;
        width: 18px;
        height: 18px;
        line-height: 18px;
        vertical-align: middle;
        text-align: center;
        border-radius: 50%;
        margin-right: 4px;
    }
    .el-tabs__header {
        margin: 0;
    }
    .el-tabs__nav-wrap:after {
        background: $border-color3;
        height: 1px;
    }
    .el-tabs__nav-scroll {
        line-height: 50px;
        padding: 0 20px;
        .el-tabs__active-bar {
            background: $color-a;
        }
        .el-tabs__item {
            font-size: $f18;
            &.is-active {
                color: $color-a;
            }
            .el-badge__content.is-fixed {
                top: 10px;
                right: 1px;
            }
        }
    }
    .el-tabs__content {
        padding: 0 0 20px;
        .fund-offset .cell {
            padding: 0 10px 0 20px;
        }
        .fund-arr {
            padding: 0 20px;
            .cell {
                padding: 0;
            }
        }
    }
    .prompt-info {
        .el-icon-warning {
            color: $color-a;
            margin-right: 8px;
            font-size: $f24;
            vertical-align: middle;
        }
        span {
            vertical-align: middle;
        }
    }
    .el-table__expand-icon {
        margin-top: 20px;
    }
    .order-table {
        .is-right.is-leaf {
            text-align: center;
        }
        td.is-right .cell {
            padding-right: 40px;
        }
    }
}
</style>
